// extracted by mini-css-extract-plugin
export default {"profile-picture":"userTable_profile-picture__gb0j-","profile-picture__container":"userTable_profile-picture__container__lygmd","table__container":"userTable_table__container__B1dsD"};